import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import Logo from '../../../img/logotipoComercam.svg';
import estilos from './CredencialComponent.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { Box, TextField } from '@mui/material';
import { obtenerEstadisticas } from '../../../redux/DucksAtencionACliente/UsuariosAtencionAClienteDuck';
import moment from 'moment'
// import {DateRangePicker, DateRange} from '@mui/lab
function CredencialComponent(props) {
    const dispatch = useDispatch()
    const usuario = props.usuario
    var fechaHoy = moment().format('YYYY-MM-DD')
    // const [value, setValue] = React.useState<DateRange<Date>>([null, null]);
    // const estadisticaUsuario = useSelector( store => store.UsuariosAtencionACliente.estadisticaUsuario )
    const [estadisticaUsuario, setEstadisticaUsuario] = React.useState('')
    const [rangoInicio, setRangoInicio] = React.useState('')
    const [rangoFin, setRangoFin] = React.useState('')

    const estadistica = async () => {
        if(rangoInicio !== '' && rangoFin !== ''){
            const result = await dispatch(obtenerEstadisticas({usuario: usuario.datoslogin.nombre + ' ' + usuario.datoslogin.apellidos, rangoInicio, rangoFin}))
            setEstadisticaUsuario(result.payload)    
        }
        
    }
    return (
        <Fragment><br />
            <div className='container'>
                <div className='row'>
                    <div className={`col-9 mt-4 ${estilos.titular}`}>
                    ESTADÍSTICA DE SOLICITUDES ATENTEDIDAS
                    </div>
                    <div className='col-3' style={{ textAlign: 'right', paddingRight: '10%' }}>
                        <img src={Logo} width='110px' />
                    </div>

                </div>
                <div className='row text-center mt-3'>
                    {/* <strong>Información</strong><br></br><br></br> */}
                    <hr />
                </div>
                <div className='row'>
                    {/* <div className='col-4'>
                        <img src={props.inspector.imagen} className='img-fluid' width={400} />
                    </div> */}

                    <div className='col-4'>
                        <strong>Usuario Atención a Cliente</strong><br></br>
                        Nombre:<br></br><p className={`${estilos.titular}`}>{usuario.datoslogin.nombre} {usuario.datoslogin.apellidos}</p>
                        Celular:<p className={`${estilos.titular}`}>{usuario.datoslogin.telefono}</p>
                        Puesto:<p className={`${estilos.titular}`}>{usuario.idrol === 2 ? 'Ejecutivo Atención a Cliente' : usuario.idrol === 1 ? 'Jefe de atención a cliente' :'Recepcionista'}</p>
                    </div>

                    <div className='col-7'>
                        
                        {/* <div className='text-center'>
                            <label htmlFor='inicio'> Inicio: </label>
                            <input className={`ms-2 ${estilos.fecha}`} type="date" id='inicio' />
                            <label className='ms-2' htmlFor='fin'> Fin: </label>
                            <input className='ms-2' type="date" id='fin' />
                        </div> */}
                        <div className=''>
                            <label><b>Indica el rango de busqueda: </b></label>
                        </div>
                        <div className="input-group input-daterange">
                            <input type="date" className="form-control" max={rangoFin !== '' ? rangoFin : fechaHoy} value={rangoInicio} onChange={e => {setRangoInicio(e.target.value), e.target.value > rangoFin && setRangoFin(e.target.value)}}/>
                            <div className="input-group-addon mt-1 ms-1">a</div>
                            <input type="date" className="form-control ms-1" max={fechaHoy} value={rangoFin} onChange={e => {setRangoFin(e.target.value), e.target.value < rangoInicio && setRangoInicio(e.target.value)}}/>
                            <button className='btn btn-outline-success btn-sm ms-1' onClick={() => estadistica()}>Ver</button>
                        </div>
                        <table className={`table mt-2`}>
                            <thead>
                                <tr>
                                    <td className={`${estilos.td} text-center`} colSpan='2'>ESTADISTICA</td>
                                    {/* <td className={`${estilos.td}`}></td> */}
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Solicitudes totales:</td>
                                    <td>{estadisticaUsuario?.countTotalFC_01}</td>
                                </tr>
                                <tr>
                                    <td>Solicitudes nuevas:</td>
                                    <td>{estadisticaUsuario?.countNuevasFC_01}</td>
                                </tr>
                                <tr>
                                    <td>Solicitudes en proceso:</td>
                                    <td>{estadisticaUsuario?.countProcesoFC_01}</td>
                                </tr>
                                <tr>
                                    <td>Solicitudes devueltas al usuario:</td>
                                    <td>{estadisticaUsuario?.countDevueltasFC_01}</td>
                                </tr>
                                <tr>
                                    <td>Solicitudes recibidas corregidas:</td>
                                    <td>{estadisticaUsuario?.countCorregidasFC_01}</td>
                                </tr>
                                <tr>
                                    <td>Solicitudes aceptadas:</td>
                                    <td>{estadisticaUsuario?.countAceptadasFC_01}</td>
                                </tr>
                                {/* <tr>
                                    <td>Nivel de atención:</td>
                                    <td><button className='badge btn-success'>Alto</button></td>
                                </tr> */}
                            </tbody>
                        </table>
                        {/* <table className='table text-center'>
                            <thead>
                                <tr>
                                    <td className={`${estilos.td}`}>ESTADO</td>
                                    <td className={`${estilos.td}`}>DÍAS</td>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    programacion.map((pro, index) => (
                                        <tr className='text-center'>
                                            <td >{pro.estado}</td>
                                            <td>del {pro.fechaInicio} al {pro.fechaFin} </td>
                                        </tr>
                                    ))
                                }

                            </tbody>

                        </table> */}
                    </div>

                </div>
                <br></br>



            </div>



        </Fragment>
    );
};


export default withRouter(CredencialComponent)
